import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
import { CredentialsBar } from './CredentialsBar';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-790">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-791">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-792">
          <div className="md:col-span-2" data-id="element-793">
            <Link to="/" className="inline-block mb-4" data-id="element-794">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-795" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-796">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-797">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-798">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-799">
              <li data-id="element-800">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-801">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-802">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-803">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-804">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-805">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-806">
              Our Network
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-807">
              <li data-id="element-808">
                <a href="https://253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-809">
                  253gravel.com
                </a>
              </li>
              <li data-id="element-810">
                <a href="https://206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-811">
                  206gravel.com
                </a>
              </li>
              <li data-id="element-812">
                <a href="https://425gravel.com" className="hover:text-white/70 transition-colors" data-id="element-813">
                  425gravel.com
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-814">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-815">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-816">
              <li className="flex justify-between" data-id="element-817">
                <span data-id="element-818">{t('footer.monFri')}</span>
                <span data-id="element-819">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-820">
                <span data-id="element-821">{t('footer.saturday')}</span>
                <span data-id="element-822">6:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-823">
                <span data-id="element-824">{t('footer.sunday')}</span>
                <span data-id="element-825">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-826">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-827">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-828">
              <li data-id="element-829">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-830">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-831">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-832">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-833">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-834">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-835">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-836">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-837">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-838">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-839">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-840">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-841">
          <p data-id="element-842">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-843">
            <a href="#" className="hover:text-white transition-colors" data-id="element-844">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-845">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
      <CredentialsBar data-id="element-846" />
    </footer>;
}